import {
    DatePattern,
    DatePatternCreate,
    DatePatternRangeQuery,
    DatePatternRangeRequest,
    UpdateDatePatternRequest
} from "./@types/DatePattern";
export class DatePatternRepository {
    private httpService: IHttpService;
    private baseUrl: string;

    constructor(httpService: IHttpService) {
        this.httpService = httpService;
        this.baseUrl = '/date_patterns';
    }
    async getAll(filters?: Record<string, any>): Promise<DatePattern[]>{
        const response = await this.httpService.get<TKResponse<DatePattern[]>>(this.baseUrl, filters);
        return response.data.sort((a, b) => ((a as any).name ?? '').localeCompare((b as any).name ?? ''));
    }
    async getOne(id: number): Promise<DatePattern> {
        const response = await this.httpService.get<TKResponse<DatePattern>>(`${this.baseUrl}/${id}`);
        return response.data;
    }
    async create(data: DatePatternCreate): Promise<DatePattern> {
        const response = await this.httpService.post<TKResponse<DatePattern>, DatePatternCreate>(this.baseUrl, {data});
        return response.data;
    }
    async update(id: number, data: UpdateDatePatternRequest): Promise<DatePattern> {
        const response = await this.httpService.patch<TKResponse<DatePattern>, UpdateDatePatternRequest>(`${this.baseUrl}/${id}`, {data});
        return response.data;
    }
    async getRangeById(id: number, filters?: DatePatternRangeQuery): Promise<string[]> {
        const response = await this.httpService.get<TKResponse<string[]>>(`${this.baseUrl}/${id}/range`, { params: filters });
        return response.data;
    }
    async range(data: DatePatternRangeRequest): Promise<string[]> {
        const response = await this.httpService.post<TKResponse<string[]>, DatePatternRangeRequest>(`${this.baseUrl}/range`, { data });
        return response.data;
    }
    async delete(id: number): Promise<void> {
        return await this.httpService.delete(`${this.baseUrl}/${id}`);
    }
}

